import React from 'react';

import Header from '../../layout/Header.jsx';
import ListBanners from '../../lists/ListBanners.jsx';

const PageBannersList = () => (
  <div>
    <Header>Banners</Header>
    <ListBanners />
  </div>
);

export default PageBannersList;
